/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Create deposit address request.
 */
export interface CreateDepositAddressRequest {
  accountId: number;
  /**
   * External asset name from Fireblocks asset info.
   */
  fireblocksAssetName: string;
}
